"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFramePromotionSearchModel = instanceOfFramePromotionSearchModel;
exports.FramePromotionSearchModelFromJSON = FramePromotionSearchModelFromJSON;
exports.FramePromotionSearchModelFromJSONTyped = FramePromotionSearchModelFromJSONTyped;
exports.FramePromotionSearchModelToJSON = FramePromotionSearchModelToJSON;
exports.FramePromotionSearchModelToJSONTyped = FramePromotionSearchModelToJSONTyped;
/**
 * Check if a given object implements the FramePromotionSearchModel interface.
 */
function instanceOfFramePromotionSearchModel(value) {
    return true;
}
function FramePromotionSearchModelFromJSON(json) {
    return FramePromotionSearchModelFromJSONTyped(json, false);
}
function FramePromotionSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'promotionName': json['promotionName'] == null ? undefined : json['promotionName'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}
function FramePromotionSearchModelToJSON(json) {
    return FramePromotionSearchModelToJSONTyped(json, false);
}
function FramePromotionSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'promotionName': value['promotionName'],
        'status': value['status'],
    };
}
